/* eslint-disable no-console */

const globalDebug = false;
/**
 * Measuring time of function call
 *
 * @param f target function
 * @param name (optional) name of function if needed
 * @param debug
 * @returns {*}
 */
export function time(f, name = '', debug = globalDebug) {
  // TODO: pass "this" scope when debug/globalDebug = true
  if (!debug) return f;
  return function (...args) {
    console.log(`${name || f.name} started...`);
    const t0 = performance.now();
    const result = f(...args);
    if (result instanceof Promise) {
      result.then(() => {
        const t1 = performance.now();
        console.log(`${name || f.name} took ${t1 - t0} ms.`);
      });
    } else {
      const t1 = performance.now();
      console.log(`${name || f.name} took ${t1 - t0} ms.`);
    }
    return result;
  };
}
